/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

/* istanbul ignore file*/
import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DownloadService } from '../services/download.service';
import { ContentItemDto } from 'api/models';
import { ContentToCopyRequest } from 'api/models/content-to-copy-request';
import { SearchContentService } from 'api/services';
import { UploadService } from '../services/upload.service';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { IPaginationService } from 'src/app/models/interfaces/IPaginationService';

@Component({
  // tslint:disable-next-line: component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'dropdown-select',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css'],
})
export class DropdownComponent implements OnInit {
  // tslint:disable-next-line: max-line-length
  constructor(
    private downloadService: DownloadService,
    public uploadService: UploadService,
    private searchContent: SearchContentService
  ) {}
  @Output() downloadClick = new EventEmitter<boolean>();

  selectedFileTypes: string[];
  @Output() checkBoxClick = new EventEmitter<any>();
  @Input() selectedContentItems: ContentItemDto[];
  @Input() downloadOption: boolean;
  @Input() paginationService: IPaginationService;
  @Input() copyOption: boolean;
  @Input() copyAllOption: boolean;
  @Input() showDropdown: boolean;
  @Input() uploadOption: boolean;
  @Output() resetSelection = new EventEmitter();

  // tslint:disable-next-line: new-parens
  optionsSelected: string[] = [];
  isDisabled = true;
  selectedFiles = [];
  selectedFilesForUpload = [];
  files = new FormControl();
  filesList: string[];
  contentToCopyRequest: ContentToCopyRequest = { fittingEntryIds: [] };
  containerName = 'sysquecontentstg';

  ngOnInit(): void {
    this.searchContent
      .getBlobFolderNamesAsync({ containerName: this.containerName })
      .subscribe((folder) => {
        this.filesList = folder;
        this.filesList.push('Itm');
      });
  }

  isSelected() {
    return this.selectedFileTypes !== undefined &&
      this.selectedFileTypes.length > 0 &&
      this.selectedContentItems !== undefined &&
      this.selectedContentItems.length > 0 &&
      this.downloadService.getDonwloadState()
      ? false
      : true;
  }

  hasSelectedContentToCopy() {
    return this.uploadService.getCopyStatus() &&
      this.selectedContentItems !== undefined &&
      this.selectedContentItems.length > 0
      ? false
      : true 
  }

  isUploading() {
    return this.uploadService.getUploadStatus();
  }

  hasFittingSelected() {
    return this.selectedContentItems !== undefined &&
      this.selectedContentItems.length > 0 &&
      !this.uploadService.getUploadStatus()
      ? false
      : true;
  }

  onCheckboxAction(element: MatSelectChange) {
    this.selectedFileTypes = element.value;
  }

  onDownloadClick() {
    if (
      this.selectedFileTypes !== undefined &&
      this.selectedFileTypes.length > 0
    ) {
      this.downloadService.setContentItems(this.selectedContentItems);
      this.downloadService.setRevitYears(this.selectedFileTypes.join(','));
      this.downloadService.onDownloadAction();
      this.resetSelection.emit(true);
    }
  }

  _onFilesChanged(files: FileList) {
    this.selectedFiles = [];
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.selectedFiles.push(files[i]);
    }
    this.uploadService.setSelectedFiles(this.selectedFiles);
    this.uploadService.onGetUploadFiles();
  }

  onCopyClick() {
    if (
      this.selectedContentItems !== null &&
      this.selectedContentItems.length > 0
    ) {
      this.uploadService.setContentItems(this.selectedContentItems);
      this.contentToCopyRequest.fittingEntryIds = this.selectedContentItems.map(
        (item) => item.fittingEntryID
      );
     
      this.uploadService.onCopyItems(this.contentToCopyRequest);
    }
  }

  hasNoManufactereOrkeyword() {
    return (
      (this.paginationService.getKeywordAndManufacturer().keyword === null ||
      this.paginationService.getKeywordAndManufacturer().keyword ===
        undefined) &&
      (this.paginationService.getKeywordAndManufacturer().manufacturer ===
        null ||
      this.paginationService.getKeywordAndManufacturer().manufacturer ===
        undefined)
        || !this.uploadService.getCopyStatus()
    );
  }

  onCopyAllClick() {
    this.uploadService.onCopyAllItems({
      filterText: this.paginationService.getKeywordAndManufacturer().keyword,
      manufacturerName:
        this.paginationService.getKeywordAndManufacturer().manufacturer,
      pageable: { pageNumber: 1, pageSize: 100 },
    });
  }

  onUploadClick() {
    this.selectedFilesForUpload = [];

    this.uploadService.setRevitYears(this.filesList.join(','));

    if (
      this.selectedContentItems !== null &&
      this.selectedContentItems.length > 0
    ) {
      this.selectedContentItems.forEach((selectedItem) => {
        this.selectedFiles.forEach((selectedFile) => {
          if (
            selectedFile.webkitRelativePath ===
            selectedItem.relativeFileLocation
          ) {
            this.selectedFilesForUpload.push(selectedFile);
          }
        });
      });
      this.uploadService.setSelectedFiles(this.selectedFilesForUpload);
      this.uploadService.setContentItems(this.selectedContentItems);
      this.uploadService.onUploadFiles();
      this.resetSelection.emit(true);
    }
  }
}
